import React from "react";
import Firebase from "../../../firebasehelper";
import "./index.css";
class IconStore extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      icons: []
    };
  }
  async componentDidMount() {
    this.setState({ loading: true });
    let result = await Firebase.getAllStoreIcons();
    this.setState({ icons: result });
    this.setState({ loading: false });
  }
  onSelectImage = image_url => {
    const { onSelectImage } = this.props;
    onSelectImage(image_url);
  };
  showAllIcons = () => {
    const { icons } = this.state;
    console.log("icons", icons);
    return icons.map(item => {
      return (
        <button
          style={{
            backgroundImage: `url(${item})`
          }}
          onClick={() => this.onSelectImage(item)}
        ></button>
      );
    });
  };
  render() {
    const { loading } = this.state;
    return (
      <div className="iconStore">
        {!loading ? (
          this.showAllIcons()
        ) : (
          <div className="loading-bar">
            <i className="fa fa-4x fa-sync fa-spin text-muted" />
          </div>
        )}
      </div>
    );
  }
}
export default IconStore;



// WEBPACK FOOTER //
// ./src/screens/super_chatbots/components/IconStore.js